import debounce from 'lodash/debounce';
import dynamic from 'next/dynamic';
import TopBanner from './components/TopBanner';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFFlower from '@/components/UI/svg/crowdfunding/EFFlower';
import EfLink from '@elem/ui/ef-link';

const Spec = dynamic(() => import('./components/Spec'), { ssr: true });
const Support = dynamic(() => import('./components/Support'), { ssr: true });
const Bundles = dynamic(() => import('./components/Bundles'), { ssr: true });
const Product = dynamic(() => import('./components/Product'), { ssr: true });

export default function CrowdFundingH5({
    productDetail,
    resProductCatagory,
    supportData,
    nowSysTime,
    bundlesData,
    bannerData,
    crowdfundingTimeline,
    shopifyBtnProps,
    activityId,
    isPreOrder,
    Com,
    showCalculator,
    theme = 'white',
    tabChange,
    needEmail = false,
    getShopifyPrice = false,
    hideBundles = false,
}: any) {
    const { useState, useEffect, useRouter, useLang, gtm } = useGlobal();
    const { t } = useLang('shared');
    const { locale, query } = useRouter();
    // 当前tab
    const [activeTab, setActiveTab] = useState(query?.tab || 'product');
    const [bannerSubTitle, setBannerSubTitle] = useState('');
    const [days, setDays] = useState(0);
    const [countdownTime, setCountdownTime] = useState(null);
    const [top, setTop] = useState(0);

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const changeTab = (tab: string) => {
        setActiveTab(tab);
        const lineEl = document.querySelector('.gap') as HTMLElement;
        const productNav = document.querySelector('.crowdfunding-tabs-nav') as HTMLElement;
        const proNavOffH = lineEl?.offsetTop + lineEl?.offsetHeight + productNav?.offsetHeight || 834;
        // product border 动画
        const scrollTop = tab === 'product' ? proNavOffH + 4 : proNavOffH;
        window.scrollTo({
            top: scrollTop,
            behavior: 'smooth',
        });
        tabChange && tabChange(tab);
        // gtm.push({
        //     event: 'uaEvent',
        //     event_name: 'pre_order_navigation',
        //     navigation_name: tab,
        // });
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: t(`crowdfunding.tabs.${tab}`),
        });
    };

    useEffect(() => {
        const renderFrostNav = debounce(() => {
            const lineEl = document.querySelector('.gap') as HTMLElement;
            const proNavOffH = lineEl?.offsetTop + lineEl?.offsetHeight || 784;
            const productNav = document.querySelector('.crowdfunding-tabs-nav') as HTMLElement;
            productNav?.classList.toggle('frost', productNav?.offsetTop > proNavOffH);
        }, 100);

        document.addEventListener('scroll', renderFrostNav);
        return () => {
            document.removeEventListener('scroll', renderFrostNav);
        };
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const bar = document.querySelector('.announcement-bar') as HTMLElement;
                if (bar) {
                    const styles = window.getComputedStyle(bar);
                    const position = styles.position;
                    setTop(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
                }
            }, 3000);
        }
    }, []);

    // useEffect(() => {
    //     if (query?.tab === 'bundles') {
    //         const lineEl = document.querySelector('.gap') as HTMLElement;
    //         const productNav = document.querySelector('.crowdfunding-tabs-nav') as HTMLElement;
    //         const proNavOffH = lineEl?.offsetTop + lineEl?.offsetHeight + productNav?.offsetHeight || 834;
    //         // product border 动画
    //         const scrollTop = proNavOffH;
    //         window.scrollTo({
    //             top: scrollTop,
    //             behavior: 'smooth',
    //         });
    //     }
    // }, [query]);

    return (
        <div className={`crowdFundingH5 ${css.crowdfunding} ${bannerData?.note ? 'hasNote' : ''}`}>
            {/* // 母亲节促销 @陈琨要求加一个母亲节促销文案, 仅限blade */}
            {bannerData?.note && (
                <div className="top-note">
                    <div className="top-icon">
                        <EFFlower width=".2rem" height=".2rem" />
                    </div>
                    <div className="top-text">{bannerData?.note}</div>
                    <div className="top-icon">
                        <EFFlower width=".2rem" height=".2rem" />
                    </div>
                </div>
            )}
            {/* 欧洲6站夏日促销 */}
            {bannerData?.promotion && <p className="top-promotion">{bannerData?.promotion}</p>}
            <TopBanner
                bannerData={{ ...bannerData, subTitle: bannerSubTitle, days, countdownTime }}
                activeTab={activeTab}
                callBack={setActiveTab}
                activityId={activityId}
                isPreOrder={isPreOrder}
                showCalculator={showCalculator}
                hideBundles={hideBundles}
            />
            <div className="gap"></div>
            <div className={`crowdfunding-tabs-nav nav-${activeTab} ${theme}`} style={{ top: `${top}px` }}>
                <div className="nav-wrapper">
                    <ul className="right-tabs" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                        <li className={`tab-item tab-product ${activeTab === 'product' ? 'active' : ''}`} onClick={() => changeTab('product')}>
                            {t('crowdfunding.tabs.product')}
                        </li>
                        {!hideBundles && (
                            <li className={`tab-item tab-bundles ${activeTab === 'bundles' ? 'active' : ''}`} onClick={() => changeTab('bundles')}>
                                {t('crowdfunding.tabs.bundles')}
                            </li>
                        )}
                        <li className={`tab-item tab-specs ${activeTab === 'specs' ? 'active' : ''}`} onClick={() => changeTab('specs')}>
                            {t('crowdfunding.tabs.specs')}
                        </li>
                        <li className={`tab-item tab-support ${activeTab === 'support' ? 'active' : ''}`} onClick={() => changeTab('support')}>
                            {t('crowdfunding.tabs.support')}
                        </li>
                        {productDetail?.buyLink && (
                            <EfLink className="tab-item tab-buy" href={productDetail?.buyLink || ''}>
                                {t('crowdfunding.header.order_now')}
                            </EfLink>
                        )}
                    </ul>
                </div>
            </div>
            <div className="crowdfunding-tabs-content">
                <div className={`content-item content-product ${activeTab === 'product' ? 'show' : 'hide'}`}>
                    <Product Com={Com} needEmail={needEmail} />
                </div>
                {!hideBundles && (
                    <div className={`content-item content-bundles ${activeTab === 'bundles' ? 'show' : 'hide'}`}>
                        <Bundles
                            bundlesData={bundlesData}
                            shopifyBtnProps={shopifyBtnProps}
                            crowdfundingTimeline={crowdfundingTimeline}
                            nowSysTime={nowSysTime}
                            activeTab={activeTab}
                            activityId={activityId}
                            callbackSubtitle={setBannerSubTitle}
                            callbackDays={setDays}
                            days={bannerData?.days}
                            callbackCountdown={setCountdownTime}
                            topCountdown={bannerData?.showCountdown}
                            getShopifyPrice={getShopifyPrice}
                        />
                    </div>
                )}
                <div className={`content-item content-specs ${activeTab === 'specs' ? 'show' : 'hide'}`}>
                    <Spec productDetail={productDetail} resProductCatagory={resProductCatagory} />
                </div>
                <div className={`content-item content-support ${activeTab === 'support' ? 'show' : 'hide'}`}>
                    <Support supportData={supportData} />
                </div>
            </div>
        </div>
    );
}
